<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        class="d-flex gap-2 flex-wrap"
        :data-type="context.type"
    >
        <div 
            v-for="opt of finalOptions" 
            :key="opt" 
            class="field-radiobutton badge-options d-flex align-items-center justify-content-between pl-2 rounded"
            :class="opt === context.model ? 'is-selected' : 'not-selected'"
        >
            <RadioButton 
                :id="opt" name="category" 
                :value="opt" 
                v-model="context.model" 
            />
            <label :for="opt" class="mb-0 pl-1 py-2 pr-2">
                <b-badge
                    :variant="opt"
                    :class="badgeClass"
                >
                    {{ badgeText }}
                </b-badge>
            </label>
        </div>
    </div>
</template>

<script>
import RadioButton from 'primevue/radiobutton';

export default {
    name: 'FormulateBadgePicker',
    components: {
        RadioButton,
    },
    mixins: [
    ],
    props: {
        context: {  // the required Formulate context prop
            type: Object,
            required: true,
        },
        options: {
            type: Array,  // array of strings, possible 'variant' values
            required: false,
        },
        badgeText: {
            type: String,
            default: 'Text Here',
        },
        badgeClass: {
            // passed directly to b-badge component
            type: [String, Array, Object],
            default: '',
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            // selected: '',  // just update context.model directly
        }
    },
    computed: {
        finalOptions() {
            // depending on what type of formulate input we choose, options may or may not actually get passed on as a prop
            // but if not, they may be in context.options - so try that
            // ALSO, if they are in this.context.options, formulate makes them OBJECTS (label, value) - just map the ID
            const opts = this.options ?? this.context?.options?.map(opt => opt.value);
            return (!!opts && Array.isArray(opts)) ? opts : [];
        }
    },
    mounted: function() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

    }
}
</script>

<style lang="scss" scoped>

.badge-options {
    background-color: transparent;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    cursor: pointer;
    label {
        cursor: pointer;
    }
    &.is-selected {
        background-color: $gray-200;
        border-color: $gray-400;
    }
}

</style>